'use client'

import { useCallback, useState } from 'react'

export const TRANSFER_CONSENT_KEY = 'stammbaum-chat-transfer-consent'

/**
 * Art. 49 GDPR consent to send chat messages to OpenCode (Singapore).
 * Separate from the "save conversation" consent. Persisted in localStorage.
 */
export function useTransferConsent() {
  const [granted, setGranted] = useState<boolean>(() => {
    if (typeof window === 'undefined') return false
    try {
      return localStorage.getItem(TRANSFER_CONSENT_KEY) === 'granted'
    } catch {
      return false
    }
  })

  const grant = useCallback(() => {
    setGranted(true)
    try {
      localStorage.setItem(TRANSFER_CONSENT_KEY, 'granted')
    } catch {
      /* localStorage unavailable */
    }
  }, [])

  const withdraw = useCallback(() => {
    setGranted(false)
    try {
      localStorage.removeItem(TRANSFER_CONSENT_KEY)
    } catch {
      /* ignore */
    }
  }, [])

  return { granted, grant, withdraw }
}
